import React, { ReactElement, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./index.less";
import { getAfterSaleProgress } from "../../../../api/filling-pile";
import { getLoginInfoPromise, getPlatform } from "../../../../utils/common";
import { formateDatePile } from "../../../../utils/common";
import FullLoading from "../../../../components/full-loading";
import check from "@assets/check.png";
import checked from "@assets/checked.png";
import bigCircular from "@assets/big-circular.png";
import smallCircular from "@assets/small-circular.png";
import redCirdular from "@assets/red-circular.png";
import star from "@assets/star.png";
import yellowStar from "@assets/yellow-star.png";
import { afterSalesOorderStatus } from "./config";

const questionInfoList = [
  { name: "上门维修不及时", value: "lowSpeed" },
  { name: "不按收费标准收费", value: "arbitraryCharge" },
  { name: "维修师傅态度差", value: "badAttitude" },
  { name: "维修质量差", value: "poorRepairQuality" },
  { name: "其他", value: "other" }
];

const AfterSalesService = (): ReactElement => {
  const router = useHistory();
  const loc = useLocation();
  const orderNo: any = new URLSearchParams(loc.search).get("orderNo");
  const [orderInfo, setOrderInfo] = useState<any>();
  const gotoPage = () => {
    router.push({
      pathname: "/maintenance-results",
      search: "?orderNo=" + (orderInfo.orderNo ? orderInfo.orderNo : "")
    });
  };
  const setTitle = () => {
    document.title = "申请售后服务";
  };
  const gotoEvaluation = () => {
    router.push({
      pathname: "/after-sale-questionnaire-survey",
      search: "?orderNo=" + (orderInfo.orderNo ? orderInfo.orderNo : "")
    });
  };

  const [evaluateGrade, setEvaluateGrade] = useState([
    star,
    star,
    star,
    star,
    star
  ]);
  const [questionInfo, setQuestionInfo] = useState<any>();

  const urge = () => {
    // console.log('催办')
    router.push({
      pathname: "/urging",
      search: "?orderNo=" + (orderInfo.orderNo ? orderInfo.orderNo : ""),
      orderType: "afterSales"
    });
  };

  useEffect(() => {
    console.log("orderNo", orderNo);
    FullLoading.show({
      text: "加载中"
    });
    setTitle();
    const phoneModel = getPlatform();
    getLoginInfoPromise()
      .then(res => {
        let name: string = res.username;
        if (phoneModel === "android") {
          name = res.nickname;
        }
        getAfterSaleProgress({
          uid: res.uid,
          name: name,
          orderNo: orderNo
        })
          .then(info => {
            console.log("售后orderInfo", info, info.data.questionnaireInfo);
            setOrderInfo(info.data);

            if (info.data.questionnaireInfo) {
              setQuestionInfo(info.data.questionnaireInfo);
              console.log("问卷内容", info.data.questionnaireInfo);
              let newArr = evaluateGrade;
              for (let i = 0; i < info.data.questionnaireInfo.mark; i++) {
                newArr[i] = yellowStar;
                // console.log(newArr[i]);
              }
              console.log("售后评价星数量", newArr);
              setEvaluateGrade([...newArr]);
            }
            FullLoading.hide();
          })
          .catch(err => {
            console.log("err", err);
            FullLoading.hide();
          });
      })
      .catch(error => {
        console.log("error", error);
        FullLoading.hide();
      });
  }, []);

  return (
    <div className="service">
      <div className="content">
        <div className="schedule">
          <div className="steps">
            <img src={checked} alt="" className="steps-icon"></img>
            <p className="liner2"></p>
            <img
              src={orderInfo && orderInfo.orderStatus >= 4 ? checked : check}
              alt=""
              className="steps-icon"
            ></img>
            <p className="liner2"></p>
            <img
              src={orderInfo && orderInfo.orderStatus >= 5 ? checked : check}
              alt=""
              className="steps-icon"
            ></img>
          </div>
          <div className="steps-title">
            <div className="text">申请售后</div>
            <div className="text center">上门维修</div>
            <div className="text">完成</div>
          </div>
        </div>
        <div className="speed-content">
          <div className="fill">
            {orderInfo && orderInfo.finishQuestionnaire === 1 ? (
              <div className="evaluate">
                <img src={bigCircular} alt="" className="bigCircular" />
                <div className="evaluate-info">
                  <div className="info-title">
                    我的评价：
                    {evaluateGrade &&
                      evaluateGrade.map((item, index) => (
                        <img src={item} alt="" key={index} />
                      ))}
                  </div>
                  {questionInfo && (
                    <div className="info-text">
                      {questionInfoList.map((item, index) => {
                        return (
                          <div key={index}>
                            {questionInfo[item.value] === 1 ? item.name : ""}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className="info-content">
                    {questionInfo && questionInfo.info}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {orderInfo &&
            orderInfo.orderStatus > 4 &&
            orderInfo.orderStatus !== 8 &&
            orderInfo.finishQuestionnaire !== 1 ? (
              <div className="property">
                <img src={bigCircular} alt="" className="bigCircular" />
                <div className="evaluation-card">
                  <div className="title">
                    <div className="title-text">请评价本次服务</div>
                    <button className="evaluation" onClick={gotoEvaluation}>
                      去评价
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {orderInfo &&
            orderInfo.orderStatus > 4 &&
            orderInfo.orderStatus !== 8 ? (
              <div className="installation">
                <img src={smallCircular} alt="" className="smallCircular" />
                <div className="info">
                  <div className="info-title">
                    <div>已确认维修结果</div>
                    <button onClick={gotoPage}>维修报告</button>
                  </div>
                  <div className="info-text">
                    预约时间：
                    {orderInfo && formateDatePile(orderInfo.repairTime)}
                  </div>
                  <div className="info-text">
                    维修费用：{orderInfo && orderInfo.repairFee}元
                  </div>
                  <div></div>
                </div>
              </div>
            ) : (
              ""
            )}

            {orderInfo && orderInfo.orderStatus === 4 ? (
              <div className="property">
                <img src={bigCircular} alt="" className="bigCircular" />
                <div className="survey-res">
                  <div className="title">
                    <div className="text">请确认维修结果</div>
                  </div>
                  <div className="surveyDate">
                    维修时间：
                    {orderInfo && formateDatePile(orderInfo.repairTime)}
                  </div>
                  <div className="survey-fee">
                    维修费用：<span>{orderInfo && orderInfo.repairFee}元</span>
                  </div>
                  <div className="btn">
                    <div></div>
                    <button onClick={gotoPage}>去确认</button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {orderInfo &&
            orderInfo.orderStatus >= 3 &&
            orderInfo.orderStatus !== 8 ? (
              <div className="site-survey">
                <div>
                  <p>上门维修</p>
                </div>
                <img src={bigCircular} alt="" className="bigCircular" />
              </div>
            ) : (
              ""
            )}

            {orderInfo &&
            (orderInfo.orderStatus === 3 ||
              orderInfo.orderStatus === 2 ||
              orderInfo.orderStatus === 1) ? (
              <div className="comes-install">
                <img src={bigCircular} alt="" className="bigCircular" />
                <div className="install-box">
                  <div className="title">
                    <div className="title-text">等待家充管家联系</div>
                    {[
                      afterSalesOorderStatus.SIGN_FOR.orderStatus,
                      afterSalesOorderStatus.REPAIR.orderStatus
                    ].includes(orderInfo.orderStatus) ? (
                      <div>
                        {orderInfo && orderInfo.urgeCount >= 1 ? (
                          <div className="urged">今日已催办</div>
                        ) : (
                          <div className="urge" onClick={urge}>
                            催办
                          </div>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="notice">家充管家24小时内联系沟通</div>
                </div>
              </div>
            ) : (
              ""
            )}

            {orderInfo && orderInfo.orderStatus === 8 ? (
              <div className="site-survey">
                <div>
                  <p>中途结束</p>
                </div>
                <img src={redCirdular} alt="" className="bigCircular" />
              </div>
            ) : (
              ""
            )}

            <div className="installation">
              <img src={smallCircular} alt="" className="smallCircular" />
              <div className="info">
                <div
                  className="info-title"
                  style={{ color: "rgba(102, 102, 102, 1)" }}
                >
                  已提交申请单
                </div>
                <div className="info-text">
                  申请时间：{orderInfo && formateDatePile(orderInfo.applyTime)}
                </div>
                <div className="info-text">
                  联系人：{orderInfo && orderInfo.contactName}{" "}
                  {orderInfo && orderInfo.contactPhone}
                </div>
                <div></div>
              </div>
            </div>
            <div className="title">
              <p>申请售后</p>
              <img src={bigCircular} alt="" className="bigCircular" />
            </div>
          </div>
        </div>
      </div>
      <div className="contact">
        {orderInfo && orderInfo.serviceProviderManagerPhone ? (
          <a href={`tel:${orderInfo.serviceProviderManagerPhone}`}>
            联系家充管家
          </a>
        ) : (
          <div className="text">正在为您分配家充服务管家</div>
        )}
      </div>
    </div>
  );
};

export default AfterSalesService;
